/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  BigNumberish,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../common";
import type { MlpManager, MlpManagerInterface } from "../MlpManager";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_usdg",
        type: "address",
      },
      {
        internalType: "address",
        name: "_mlp",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_cooldownDuration",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "aumInUsdg",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mlpSupply",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdgAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mintAmount",
        type: "uint256",
      },
    ],
    name: "AddLiquidity",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mlpAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "aumInUsdg",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mlpSupply",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdgAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    name: "RemoveLiquidity",
    type: "event",
  },
  {
    inputs: [],
    name: "MAX_COOLDOWN_DURATION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRICE_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDG_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minUsdg",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minMlp",
        type: "uint256",
      },
    ],
    name: "addLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_fundingAccount",
        type: "address",
      },
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minUsdg",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minMlp",
        type: "uint256",
      },
    ],
    name: "addLiquidityForAccount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "aumAddition",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "aumDeduction",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cooldownDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "maximise",
        type: "bool",
      },
    ],
    name: "getAum",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "maximise",
        type: "bool",
      },
    ],
    name: "getAumInUsdg",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAums",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gov",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "inPrivateMode",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isHandler",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lastAddedAt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mlp",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_mlpAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minOut",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
    ],
    name: "removeLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_mlpAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minOut",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
    ],
    name: "removeLiquidityForAccount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_aumAddition",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_aumDeduction",
        type: "uint256",
      },
    ],
    name: "setAumAdjustment",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_cooldownDuration",
        type: "uint256",
      },
    ],
    name: "setCooldownDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_gov",
        type: "address",
      },
    ],
    name: "setGov",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_handler",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isActive",
        type: "bool",
      },
    ],
    name: "setHandler",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_inPrivateMode",
        type: "bool",
      },
    ],
    name: "setInPrivateMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "usdg",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vault",
    outputs: [
      {
        internalType: "contract IVault",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type MlpManagerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MlpManagerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MlpManager__factory extends ContractFactory {
  constructor(...args: MlpManagerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    _vault: AddressLike,
    _usdg: AddressLike,
    _mlp: AddressLike,
    _cooldownDuration: BigNumberish,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      _vault,
      _usdg,
      _mlp,
      _cooldownDuration,
      overrides || {}
    );
  }
  override deploy(
    _vault: AddressLike,
    _usdg: AddressLike,
    _mlp: AddressLike,
    _cooldownDuration: BigNumberish,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(
      _vault,
      _usdg,
      _mlp,
      _cooldownDuration,
      overrides || {}
    ) as Promise<
      MlpManager & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): MlpManager__factory {
    return super.connect(runner) as MlpManager__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MlpManagerInterface {
    return new Interface(_abi) as MlpManagerInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): MlpManager {
    return new Contract(address, _abi, runner) as unknown as MlpManager;
  }
}
